import { useEffect, useMemo } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Group, Member } from "Types";
import { MemberFormData } from "../../types";
import { generateMemberSchema } from "../../utils";

const getInitialGroupIds = (initialGroups?: Group[]) =>
  initialGroups ? initialGroups.map((group) => group.group_id) : [];

const useEditForm = (initialValues: Member) => {
  const initialGroupIds = useMemo(
    () => getInitialGroupIds(initialValues.org_groups),
    [initialValues],
  );

  const memberSchema = generateMemberSchema();

  const formMethods = useForm<MemberFormData>({
    resolver: yupResolver(memberSchema),
    defaultValues: {
      email: initialValues.email ?? "",
      orgGroups: initialGroupIds,
      orgRole: initialValues.org_role,
    },
  });

  const formReset = formMethods.reset;

  useEffect(() => {
    formReset({
      email: initialValues.email ?? "",
      orgGroups: initialValues.org_groups?.map((group) => group.group_id) ?? [],
      orgRole: initialValues.org_role ?? "",
    });
  }, [initialValues, formReset]);

  return formMethods;
};

export default useEditForm;
